import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material';
import { SIGNIN } from './redux/actionTypes/authActionType';
import { ParentDashboard } from './Parent/Dashboard/ParentDashboard';
import LoggedIn from './Components/LoggedIn/LoggedIn';
import Homepage from './Feis-Homepage/Homepage';
import Organisers from './Site/Organisers';
import About from './Site/About';
import ScrollToTop from './Components/ScrollToTop';
import CanonicalLink from './Components/CanonicalLink';
import TransactionHistory from './Parent/Trasaction-History/TransactionHistory';
import SignIn from './Parent/Auth/SignIn';
import AddAccount from './Parent/Auth/AddAccount';
import AddDancers from './Parent/AddDancers';
import RegisterGradeEvents from './Parent/Register-Events/RegisterGradeEvents';
import { PageNotFound } from './Components/Errors/PageNotFound';
import { routesArray } from './routes';
import ResetPassword from './Parent/Auth/ResetPassword';
import FeiseannazViewEvent from './Parent/ViewEvent/FeiseannazViewEvent';
import GradeViewEvent from './Parent/ViewEvent/GradeViewEvent';
import OireachtasViewEvent from './Parent/ViewEvent/OireachtasViewEvent';
// Parent feis registration (MC2 card 9a9e350b): the old
// Register-Events/RegisterFiesanaaEvent screen is replaced.
import RegisterPage, { ChangeDancesPage } from './Parent/Register/RegisterPage';
import RegisterSuccess from './Parent/Register/RegisterSuccess';
import CompetitionCounts from './Parent/CompetitionCounts/CompetitionCounts';
import CongratratulationsGrade from './Parent/Success/CongratratulationsGrade';
// (the old feis edit screen, Register-Events/Edit-Event/FeiseannazEditEvent, is replaced by ChangeDancesPage)
import ViewFiesEdit from './Parent/ViewEditEvent/ViewFiesEdit';
import ViewGradeEdit from './Parent/ViewEditEvent/ViewGradeEdit';
import GradeEditEvent from './Parent/Register-Events/Edit-Event/GradeEditEvent';
import Confirmpasswords from './Parent/Auth/Confirmpasswords';
import PrivacyPolicy from './Pages/Legal/PrivacyPolicy';
import TermsOfService from './Pages/Legal/TermsOfService';
import EventResults from './Parent/Results/EventResults';
import ResultsHome from './Parent/Results/ResultsHome';
import OireachtasEventResults from './Parent/Results/OireachtasEventResults';
import OireachtasMyResults from './Parent/Results/OireachtasMyResults';
import StripePage from './Parent/Payments/StripePage';
import OireachtasEventPage from './Teacher/Oireachtas/OireachtasEventPage';
import OireachtasRegistration from './Teacher/Oireachtas/RegistrationShell';
import OireachtasConfirmation from './Teacher/Oireachtas/Confirmation';
import OireachtasCurrentEntries from './Teacher/Oireachtas/CurrentEntries';
import { ToastContainer, toast } from 'react-toastify';
import StripeAccount from './Organizer/Payment/StripeAccount';
import 'react-toastify/dist/ReactToastify.css';
import Account from "./Parent/Account/Account"
import DeleteAccount from "./Parent/Account/DeleteAccount";
import AdjudicatorInvite from "./Adjudicator/AdjudicatorInvite";
import { isAdjudicatorInviteRequest } from "./Adjudicator/adjudicatorApi";
import AdjudicatorProfilePage from "./Adjudicator/AdjudicatorProfilePage";
import { isDeleteAccountRefusal } from "./helper/accountDeletion";


// organizer Routes
import GradeOrg from './Organizer/CreateGradeEvent/GradeOrg';
import FiesOrg from './Organizer/CreateFeisEvent/FiesOrg';
import FinalGradeDetails from './Organizer/GoLive/FinalGradeDetails';
import LoginOrg from './Organizer/Auth/LoginOrg';
import SignupOrg from './Organizer/Auth/SignupOrg';
import ForgotPasswordOrg from './Organizer/Auth/ForgotPasswordOrg';
import ConfirmPasswordOrg from './Organizer/Auth/ConfirmPasswordOrg';
import CreateEventFromPrev from './Organizer/CreateEventFromPrev/CreateEventFromPrev';
import DashboardOrg from './Organizer/Dashboard/DashboardOrg';
import OrganizerOireachtas from './Organizer/Oireachtas/OrganizerOireachtas';
import OireachtasSchedule from './Organizer/Oireachtas/Schedule/OireachtasSchedule';
import { isOrganizerPanelPath, rememberOrganizerReturnPath, sessionEndedOnPanel } from './Organizer/Oireachtas/panelLink';
import { signOutForPasswordRecovery } from './helper/passwordRecovery';
import PayRequest from './PaymentRequest/PayRequest';
import { isPayPath, payPathSessionEnded, rememberPayPath } from './PaymentRequest/payLink';
import { isEntryLink, entryLinkSessionEnded, rememberEntryLink } from './Parent/ViewEditEvent/entryLink';
import { useSingleResponseInterceptor } from './helper/singleInterceptor';
import ManageFeisGrade from './Organizer/ManageFeisGrade/ManageFeisGrade';
import FeisCompetitors from './Organizer/ManageFeisGrade/RedirectFeis/Entries/FeisCompetitors';
import AccountOrg from './Organizer/Account/AccountOrg';
import EditCompetitors from './Organizer/ManageFeisGrade/RedirectFeis/Entries/EditCompetitors';
import EditRegister from './Organizer/ManageFeisGrade/RedirectFeis/Entries/EditRegister';
import MergeSplit from './Organizer/ManageFeisGrade/RedirectFeis/Entries/MergeSplit';
import MergeSplitFn from './Organizer/ManageFeisGrade/RedirectFeis/Entries/MergeSplitFn';
import Email from './Organizer/ManageFeisGrade/RedirectFeis/Entries/Email';
import EventDetails from './Organizer/ManageFeisGrade/RedirectFeis/Event/EventDetails';
import FinalFiezDetails from './Organizer/GoLive/FinalFiezDetails';
import CheckIn from './Organizer/ManageFeisGrade/RedirectFeis/Tabulation/CheckIn';
import ResultStatus from './Organizer/ManageFeisGrade/RedirectFeis/Tabulation/ResultStatus';
import Tabulate from './Organizer/ManageFeisGrade/RedirectFeis/Tabulation/Tabulate';
import CompleteResults from './Organizer/ManageFeisGrade/RedirectFeis/Tabulation/CompleteResults';
import ScoreCheckInDownload from './Organizer/ManageFeisGrade/RedirectFeis/Print/ScoreCheckInDownload';
import NowNextSigns from './Organizer/ManageFeisGrade/RedirectFeis/Print/NowNextSigns';
import Transactions from './Organizer/ManageFeisGrade/RedirectFeis/Financial/Transactions';
import CandidateLists from './Organizer/ManageFeisGrade/RedirectGrade/Entries/CandidateLists';
import PublishedResults from './Organizer/ManageFeisGrade/RedirectFeis/Tabulation/PublishedResults';
import EditCandidates from './Organizer/ManageFeisGrade/RedirectGrade/Entries/EditCandidates';
import GradeEditRegister from './Organizer/ManageFeisGrade/RedirectGrade/Entries/GradeEditRegister';
import DeletedEvent from './Parent/Register-Events/DeletedEvent/DeletedEvent';
import ManageSchedule from './Organizer/ManageFeisGrade/RedirectFeis/Schedule/ManageSchedule';
import AwardsTableComponent from './Organizer/AwardsTable/AwardsTableComponent';
// Event-day job devices (card 540f21a4)
import { DeviceProvider } from './device/DeviceContext';
import DeviceHome from './device/DeviceHome';
import DeviceEnded from './device/DeviceEnded';
import RequireFunction from './device/RequireFunction';
import JobDevices from './Organizer/JobDevices/JobDevices';
import PairScan from './device/PairScan';
import { FEIS_INNER_ROUTES, FEIS_SCREENS } from './device/deviceScreens';
import { forgetDevice, readDevice } from './device/deviceSession';
import { deviceErrorAction, isDeviceRequest } from './device/deviceErrors';

// The organizer screens a feis job device can open (device/deviceScreens.js).
const DEVICE_SCREEN_ELEMENTS = {
  checkin: CheckIn,
  tabulate: Tabulate,
  resultStatus: ResultStatus,
  published: PublishedResults,
  awards: AwardsTableComponent,
  sheets: ScoreCheckInDownload,
  competitors: FeisCompetitors,
  editCompetitors: EditCompetitors,
};
const DEVICE_INNER_ELEMENTS = { '/edit-register/:name': EditRegister, '/complete-results/:name': CompleteResults };

const theme = createTheme({
  palette: {
    primary: {
      main: '#68AD3F',
    },
    secondary: {
      main: '#FBB040',
    },
  },

  typography: {
    fontFamily: 'Rubik ',
    h1: {
      fontSize: '52px',
      fontWeight: 700,
    },
    h2: {
      fontSize: '40px',
      fontWeight: 500,
    },
    button: {
      textTransform: 'none',
    },
  },
});

export const AppWrapper = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  // Forgot/reset password pages are signed-out routes: an old stored login
  // must not turn an emailed reset link into the 404 page (passwordRecovery.js).
  signOutForPasswordRecovery(pathname);
  const [hasHelp, setHasHelp] = useState(true);
  const [apiAlert, setApiAlert] = useState([]);
  const [isToastVisible, setIsToastVisible] = useState(true);
  const accessToken = localStorage.getItem('accessToken');
  // a paired feis job device runs its own small set of screens
  const jobDevice = readDevice();
  const feisDevice = jobDevice && jobDevice.eventKind === 'feis' ? jobDevice : null;
  //Authenticating user while the session is live or user is logged in
  const authenticateUser = () => {
    if (accessToken) {
      dispatch({
        type: SIGNIN,
        payload: {
          accessToken,
        },
      });
    }
  };
  useEffect(() => {
    authenticateUser();
    getCountry()
  }, []);

    const getCountry = async () => {
      try {
        const url = "https://get.geojs.io/v1/ip/country.json"; // API URL

        const response = await fetch(url); // Fetch the country data
        const data = await response.json(); // Parse the JSON response

        if (data.country) {
          console.log(data.country,"country")
          dispatch({
            type:"SET_COUNTRY",
            payload:{
              country:data.country
            }
          })
        } else {
            console.log("error!")
        }
      } catch (err) {
        console.log(err)
      }
    };



  // Add a request interceptor
  axios.interceptors.request.use(
    (config) => {
      return config;
    },
    (error) => {
      Promise.reject(error);
    }
  );

  // One response interceptor for the app's lifetime (review R1-F3): it used to
  // be added again on every render, and a later duplicate could undo the
  // pay-link redirect to /login (helper/singleInterceptor.js).
  useSingleResponseInterceptor(axios, handleResponse, handleError);

  function handleResponse(response) {
    return response;
  }

  function handleError(error) {
    // A paired event-day device never signs out or clears the browser: its
    // access ended, or its job doesn't include that (card 540f21a4). Decided
    // by the request too: requests still out when the device ended carry its
    // token and must not reach the sign-out handling below.
    if (isDeviceRequest(error) || readDevice()) {
      const action = deviceErrorAction(error);
      if (action === 'ended') {
        if (readDevice()) {
          forgetDevice();
          navigate('/device-ended', { replace: true });
        }
      } else if (action === 'notGranted') {
        toast.error("This device's job doesn't include that.", { position: toast.POSITION.TOP_RIGHT });
      } else if (action === 'unavailable') {
        toast.error("That isn't available on an event device.", { position: toast.POSITION.TOP_RIGHT });
      }
      return Promise.reject(error);
    }
    // A wrong password or an organiser account on /delete-account stays on
    // the page with the server's message instead of signing out
    // (helper/accountDeletion.js).
    if (isDeleteAccountRefusal(error)) return Promise.reject(error);
    // The adjudicator invitation page handles every answer itself (a refused
    // claim offers Sign out and keeps the invitation open; card 930d3ac0).
    if (isAdjudicatorInviteRequest(error)) return Promise.reject(error);
    // An ended session on an emailed pay link (/pay/:id) goes to the parent
    // login and returns to the pay page afterwards (PaymentRequest/payLink.js).
    if (error.response && payPathSessionEnded(error.response.status, window.location.pathname)) {
      rememberPayPath(window.location.pathname);
      localStorage.clear();
      navigate('/login', { replace: true });
      return Promise.reject(error);
    }
    // An ended session on an entered-feis page (the number-card reminder
    // email's link) goes to the parent login and comes back (entryLink.js).
    if (error.response && entryLinkSessionEnded(error.response.status, window.location.pathname, window.location.search)) {
      rememberEntryLink(window.location.pathname, window.location.search);
      localStorage.clear();
      navigate('/login', { replace: true });
      return Promise.reject(error);
    }
    // An ended session on the organizer Oireachtas panel goes to the organizer
    // login and returns to the panel afterwards (panelLink.js).
    if (
      error.response &&
      sessionEndedOnPanel(
        error.response.status,
        error.response.data && error.response.data.message,
        window.location.pathname
      )
    ) {
      rememberOrganizerReturnPath(window.location.pathname);
      localStorage.clear();
      navigate('/login-org', { replace: true });
      return Promise.reject(error);
    }
    if (error.response.status === 401) {
      localStorage.clear();
      navigate('/', {
        state: { from: `${error.response.data.message.name}` },
      });
      setApiAlert(error.response.data.message);
      return Promise.reject(error);
    }

    if (error.response.status === 500) {
      if (isToastVisible) {
        toast.dismiss();
        toast.error('Some Thing went wrong', {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 100,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        });
        setIsToastVisible(false);
      }
    }

    <ToastContainer />;

    if (error.response.status === 403) {
      localStorage.clear();
      navigate('/', {
        state: { from: `${error.response.data.message}` },
      });
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }

  // const isValuableRoute = () => {
  //   const pathToMatch = window.location.pathname;

  //   for (let i = 0; i < routesArray.length; i++) {

  //     if (pathToMatch.startsWith(routesArray[i].split(':name')[0])) {
  //       return true;
  //     }
  //   }

  //   return false;
  // }


  return (
    <div className="App">
      <ScrollToTop />
      <CanonicalLink />
      <ThemeProvider theme={theme}>
        <DeviceProvider onEnded={() => navigate('/device-ended', { replace: true })}>
        {feisDevice ? (
          <Routes>
            <Route exact path="/" element={<DeviceHome />} />
            {FEIS_SCREENS.filter((sc) => sc.path).map((sc) => {
              const Screen = DEVICE_SCREEN_ELEMENTS[sc.key];
              return (
                <Route
                  key={sc.key}
                  path={sc.name ? `${sc.path}/:name` : sc.path}
                  element={
                    <RequireFunction any={sc.any}>
                      <Screen />
                    </RequireFunction>
                  }
                />
              );
            })}
            {FEIS_INNER_ROUTES.map((r) => {
              const Screen = DEVICE_INNER_ELEMENTS[r.path];
              return (
                <Route
                  key={r.path}
                  path={r.path}
                  element={
                    <RequireFunction any={r.any}>
                      <Screen />
                    </RequireFunction>
                  }
                />
              );
            })}
            <Route path="/device-ended" element={<DeviceEnded />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        ) : accessToken ? (
          <Routes>
            <Route exact path="/" element={<LoggedIn />} />
            <Route path="/add-dancers" element={<AddDancers />} />
            <Route path="/parent" element={<ParentDashboard />} />
            <Route path="/my-account" exact element={<Account />} />
            <Route path="/delete-account" element={<DeleteAccount />} />
            {/* adjudicator accounts (card 930d3ac0) */}
            <Route path="/adjudicator/invite/:token" element={<AdjudicatorInvite />} />
            <Route path="/adjudicator/profile" element={<AdjudicatorProfilePage />} />
            <Route path="/parent/transaction-history" element={<TransactionHistory />} />
            <Route path="/feis/:name" element={<FeiseannazViewEvent />} />
            <Route path="/oireachtas/event/:name" element={<OireachtasViewEvent />} />
            <Route path="/register-dancers" element={<RegisterPage />} />
            <Route path="/checkout" element={<StripePage />} />
            <Route path="/edit-feis/:name" element={<ViewFiesEdit />} />
            <Route path="/feis-edit-dancers/:id" element={<ChangeDancesPage />} />
            <Route path="/parent/feis/register/payment/success" element={<RegisterSuccess />} />
            <Route path="/parent/feis/edit-register/payment/success" element={<RegisterSuccess edit />} />
            <Route path="/grade/:id" element={<GradeViewEvent />} />
            <Route path="/register-grade-exam" element={<RegisterGradeEvents />} />
            <Route path="/edit-grade/:name" element={<ViewGradeEdit />} />
            <Route path="/grade-edit-dancers/:id" element={<GradeEditEvent />} />
            <Route path="/parent/grade/register/payment/success" element={<CongratratulationsGrade />} />
            <Route path="/parent/grade/edit-register/payment/success" element={<CongratratulationsGrade edit />} />
            <Route path="/results" element={<ResultsHome />} />
            <Route path="/results/:name" element={<EventResults />} />
            <Route path="/oireachtas/results/:name" element={<OireachtasEventResults />} />
            <Route path="/oireachtas/my-results/:name" element={<OireachtasMyResults />} />
            <Route path="/competitors/:name" element={<CompetitionCounts />} />
            <Route path="/organizer-create-grade" element={<GradeOrg />} />
            <Route path="/organizer-create-feisanna" element={<FiesOrg />} />
            <Route path="/organiser-dasboard/createevent-grade/finalGradeDetails" element={<FinalGradeDetails />} />
            <Route path="/organiser-dasboard/createevent-feisanna/finalfiesDetails" element={<FinalFiezDetails />} />
            <Route path="/previous-events" element={<CreateEventFromPrev />} />
            <Route path="/organizer-dashboard" element={<DashboardOrg />} />
            <Route path="/organizer-manage-feis" element={<ManageFeisGrade />} />
            <Route path="/organizer-manage-grade" element={<ManageFeisGrade />} />
            <Route path="/organizer-oireachtas/:id" element={<OrganizerOireachtas />} />
            <Route path="/organizer-oireachtas/:id/schedule" element={<OireachtasSchedule />} />
            <Route path="/competitorss/:name" element={<FeisCompetitors />} />
            <Route path="/candidate/:name" element={<CandidateLists />} />
            <Route path="/edit-competitors/:name" element={<EditCompetitors />} />
            <Route path="/edit-candidates/:name" element={<EditCandidates />} />
            <Route path="/my-account-org" exact element={<AccountOrg />} />
            <Route path="/organizer-account" exact element={<StripeAccount />} />
            <Route path="/edit-register/:name" exact element={<EditRegister />} />
            <Route path="/grade/edit-register/:name" exact element={<GradeEditRegister />} />
            <Route path="/oireachtas/:id" element={<OireachtasEventPage />} />
            <Route path="/teacher/oireachtas/:id/register" element={<OireachtasRegistration />} />
            <Route path="/teacher/oireachtas/:id/entries" element={<OireachtasCurrentEntries />} />
            <Route path="/teacher/oireachtas/:id/register/success" element={<OireachtasConfirmation />} />
            <Route path="/pay/:requestId" element={<PayRequest />} />
            <Route path="/merge-split/:name" exact element={<MergeSplit />} />
            <Route path="/merge-split-comp/:name" exact element={<MergeSplitFn />} />
            <Route path="/email" exact element={<Email />} />
            {/* <Route path="/event-details/:name" exact element={<EventDetails />} /> */}
            <Route path="/event-details" exact element={<EventDetails />} />
            <Route path="/check-in/:name" exact element={<CheckIn />} />
            <Route path="/result-status/:name" exact element={<ResultStatus />} />
            <Route path="/tabulate/:name" exact element={<Tabulate />} />
            <Route path="/complete-results/:name" exact element={<CompleteResults />} />
            <Route path="/score-checkin-download/:name" exact element={<ScoreCheckInDownload />} />
            <Route path="/now-next-signs/:name" exact element={<NowNextSigns />} />
            <Route path="/transaction-history-org/:name" exact element={<Transactions />} />
            <Route path="/published-results/:name" exact element={<PublishedResults />} />
            <Route path="/temporary-registration" exact element={<DeletedEvent />} />
            <Route path="/awards" exact element={<AwardsTableComponent />} />
            <Route path="/manage-schedule" exact element={<ManageSchedule />} />
            <Route path="/job-devices" exact element={<JobDevices />} />
            <Route path="/organisers" element={<Organisers />} />
            <Route path="/about" element={<About />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/device-ended" element={<DeviceEnded />} />
            {/* a phone that scanned a device's QR code (card 540f21a4) */}
            <Route path="/pair" element={<PairScan />} />
            <Route path="*" exact element={<PageNotFound />} />
          </Routes>
        ) : (
          <Routes>
            <Route exact path="/" element={<Homepage />} />
            <Route exact path="/login" element={<SignIn />} />
            <Route path="/signup" element={<AddAccount />} />
            <Route path="/forgot-password" element={<ResetPassword />} />
            {/* public: explains deletion, then log in and come back */}
            <Route path="/delete-account" element={<DeleteAccount />} />
            {/* the emailed adjudicator invitation opens signed in or out (card 930d3ac0) */}
            <Route path="/adjudicator/invite/:token" element={<AdjudicatorInvite />} />
            <Route path="/reset-password" element={<Confirmpasswords />} />
            <Route path="/add-dancers" element={<AddDancers />} />
            <Route path="/feis/:name" element={<FeiseannazViewEvent />} />
            <Route path="/grade/:name" exact element={<GradeViewEvent />} />
            {/* Oireachtas event pages are public (registration itself is teacher-gated) */}
            <Route path="/oireachtas/event/:name" element={<OireachtasViewEvent />} />
            <Route path="/oireachtas/:id" element={<OireachtasEventPage />} />
            <Route path="/login-org" element={<LoginOrg />} />
            <Route path="/signup-org" element={<SignupOrg />} />
            <Route path="/forgotpwd-org" element={<ForgotPasswordOrg />} />
            <Route path="/reset-pwd-org" element={<ConfirmPasswordOrg />} />
            <Route path="/temporary-registration" exact element={<DeletedEvent />} />
            <Route path="/results" element={<ResultsHome />} />
            <Route path="/results/:name" element={<EventResults />} />
            {/* Oireachtas published results are public (P1 my-results is login-only) */}
            <Route path="/oireachtas/results/:name" element={<OireachtasEventResults />} />
            <Route path="/organisers" element={<Organisers />} />
            <Route path="/about" element={<About />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/device-ended" element={<DeviceEnded />} />
            {/* a phone that scanned a device's QR code (card 540f21a4) */}
            <Route path="/pair" element={<PairScan />} />
            <Route path="*"
              element={
                (() => {

                  // Logged-out pay link (emailed payment request): log in,
                  // then come back to it (PaymentRequest/payLink.js).
                  if (isPayPath(window.location.pathname)) {
                    rememberPayPath(window.location.pathname);
                    return <Navigate to="/login" replace />;
                  }
                  // Logged-out link to a family's entered feis (the
                  // number-card reminder email): log in, then come back to it
                  // (Parent/ViewEditEvent/entryLink.js).
                  if (isEntryLink(window.location.pathname, window.location.search)) {
                    rememberEntryLink(window.location.pathname, window.location.search);
                    return <Navigate to="/login" replace />;
                  }
                  // Logged-out deep link to the organizer Oireachtas panel:
                  // log in, then come back to it (panelLink.js).
                  if (isOrganizerPanelPath(window.location.pathname)) {
                    rememberOrganizerReturnPath(window.location.pathname);
                    return <Navigate to="/login-org" replace />;
                  }
                  // if (routesArray.includes(window.location.pathname) || isValuableRoute()) {
                  if (routesArray.includes(window.location.pathname)) {

                    const fullPath = window.location.pathname + window.location.search;
                    const url = new URL(window.location.href);
                    const params = new URLSearchParams(url.search);
                    const id = params.get('id');
                    const type = params.get('type');
                    if (type === "redirect") {
                      localStorage.setItem("orgPath", fullPath)
                      localStorage.setItem("redirectFromOrg", "redirect")
                    } else if (window.location.pathname === "/register-dancers" && id) {
                      // Signed out on a registration link: log in, then come
                      // back to it (Parent/Auth/SignIn.jsx), as the event
                      // page's Register does.
                      localStorage.setItem("path", fullPath);
                      localStorage.setItem("eventId", id);
                      localStorage.setItem("eventType", "Feiseanna");
                      localStorage.setItem("from", "open");
                      return <Navigate to="/login" replace />;
                    }
                    return <Navigate to="/" state={{ from: '404PAGE' }} />;
                  } else {
                    return <PageNotFound />;
                  }
                })()
              }
            />
          </Routes>
        )}
        </DeviceProvider>
        <ToastContainer />
      </ThemeProvider>
    </div>
  );
};
